import { makeStyles } from '@material-ui/core';

import Colors from '../../../../constants/Colors';

export const componentSettingStyle = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'nowrap',
    padding: 24,
    flexDirection: 'column',
    border: `1px solid ${Colors.DISABLED_COLOR}`,
    justifyContent: 'space-between',
    margin: '1rem 1rem 0px 1rem',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      flexWrap: 'nowrap',
      padding: 24,
      flexDirection: 'row',
      justifyContent: 'space-between',
      margin: '1.5rem 1.5rem 0px 1.5rem',
      border: `1px solid ${Colors.DISABLED_COLOR}`,
    },
  },
  title: {
    fontSize: '17px',
    fontWeight: 'bold',
    letterSpacing: '0',
    color: Colors.PRIMARY_FONT_COLOR,
  },
  description: {
    fontFamily: 'Poppins',
    fontSize: '13px',
    letterSpacing: '0',
    color: Colors.SECONDARY_FONT_COLOR,
    paddingBottom: '30px',
  },
  alignSwitchMobile: {
    marginLeft: 'auto',
    [theme.breakpoints.up('md')]: {
      marginLeft: 'inherit',
    },
  },
}));
